import { render, staticRenderFns } from "./add_branch.vue?vue&type=template&id=857afafa&scoped=true"
import script from "./add_branch.vue?vue&type=script&lang=js"
export * from "./add_branch.vue?vue&type=script&lang=js"
import style0 from "./add_branch.vue?vue&type=style&index=0&id=857afafa&prod&lang=css"
import style1 from "./add_branch.vue?vue&type=style&index=1&id=857afafa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857afafa",
  null
  
)

export default component.exports